<template>
<div class="chapter">
<div class="inner_page">
<p class="crt"><span class="small">CONTENTS</span></p>
<p class="crt"><span href="#/OEBPS/tp" title="Link target outside of Sample">Title Page</span></p>
<p class="crt"><span href="#/OEBPS/otherbooks" title="Link target outside of Sample">Other Books by Rick Shelley</span></p>
<p class="crt"><span href="#/OEBPS/copyright" title="Link target outside of Sample">Copyright</span></p>
<p class="crt1"><a href="#/OEBPS/c01">Chapter 1</a></p>
<p class="crt"><a href="#/OEBPS/c02">Chapter 2</a></p>
<p class="crt"><span href="#/OEBPS/c03" title="Link target outside of Sample">Chapter 3</span></p>
<p class="crt"><span href="#/OEBPS/c04" title="Link target outside of Sample">Chapter 4</span></p>
<p class="crt"><span href="#/OEBPS/c05" title="Link target outside of Sample">Chapter 5</span></p>
<p class="crt"><span href="#/OEBPS/c06" title="Link target outside of Sample">Chapter 6</span></p>
<p class="crt"><span href="#/OEBPS/c07" title="Link target outside of Sample">Chapter 7</span></p>
<p class="crt"><span href="#/OEBPS/c08" title="Link target outside of Sample">Chapter 8</span></p>
<p class="crt"><span href="#/OEBPS/c09" title="Link target outside of Sample">Chapter 9</span></p>
<p class="crt"><span href="#/OEBPS/c10" title="Link target outside of Sample">Chapter 10</span></p>
<p class="crt"><span href="#/OEBPS/c11" title="Link target outside of Sample">Chapter 11</span></p>
<p class="crt"><span href="#/OEBPS/c12" title="Link target outside of Sample">Chapter 12</span></p>
<p class="crt"><span href="#/OEBPS/c13" title="Link target outside of Sample">Chapter 13</span></p>
<p class="crt"><span href="#/OEBPS/c14" title="Link target outside of Sample">Chapter 14</span></p>
<p class="crt"><span href="#/OEBPS/c15" title="Link target outside of Sample">Chapter 15</span></p>
<p class="crt"><span href="#/OEBPS/c16" title="Link target outside of Sample">Chapter 16</span></p>
<p class="crt"><span href="#/OEBPS/c17" title="Link target outside of Sample">Chapter 17</span></p>
<p class="crt"><span href="#/OEBPS/c18" title="Link target outside of Sample">Chapter 18</span></p>
<p class="crt"><span href="#/OEBPS/c19" title="Link target outside of Sample">Chapter 19</span></p>
<p class="crt"><span href="#/OEBPS/c20" title="Link target outside of Sample">Chapter 20</span></p>
<p class="crt"><span href="#/OEBPS/c21" title="Link target outside of Sample">Chapter 21</span></p>
<p class="crt1"><span href="#/OEBPS/ty" title="Link target outside of Sample">Thank You from JABberwocky!</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7b17b3e2